import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/common';

import { CommonTranslationModule, DictionaryModule } from '@sdbn/common';
import { VisitorRegistrationPreparationComponent } from './visitor-registration-preparation.component';



@NgModule({
  declarations: [
    VisitorRegistrationPreparationComponent
  ],
  imports: [
      CommonModule,
      DictionaryModule,
  
      ApplicationClientCommonModule,
      CommonTranslationModule,
  ]
})
export class VisitorRegistrationPreparationModule { }
